import React, {useEffect, useState, useRef} from "react";
import '../assets/css/color-picker.css';

const ColorPicker = ({ color, handleColorChange }) => {
    const [currentColor, setCurrentColor] = useState("#ffffff");
    const inputRef = useRef();

    const handleColorSelect = (e) => {
        setCurrentColor(e.target.value);
        handleColorChange(e.target.value);
    };

    useEffect(() => {
        if (color && color !== currentColor) {
            setCurrentColor(color);
        }
    }, [color, currentColor]);

    return (
        <div className="color-selector">
            <button
                onClick={() => inputRef.current?.click()}
                className="circle"
                style={{ backgroundColor: currentColor }}
            >
                {currentColor}
            </button>
            <input
                ref={inputRef}
                type="color"
                value={currentColor}
                onChange={handleColorSelect}
                style={{ display: "none" }}
            />
        </div>
    );
};

export default ColorPicker;
